import {
    notificationActions as C,
    notificationFilters,
    getNotificationId,
    getNotificationStats,
    matchesNotificationFilters,
    sortNotifications,
} from "../utils/adminNotificationUtils";

const initialState = () => ({
    ownerId: "",
    notifications: [],
    unreadCount: 0,
    unreadByType: getNotificationStats().unreadByType,
    nextCursor: null,
    nextCursorId: null,
    hasMore: true,
    hasLoaded: false,
    loading: false,
    error: "",
    countsError: "",
    countsLoading: false,
    generation: 0,
    requestId: 0,
    countsRequestId: 0,
    activityVersion: 0,
    readIds: {},
    readBefore: null,
    filters: { ...notificationFilters },
});

// Ответ страницы мог начаться до чтения на телефоне или в другой вкладке.
const applyKnownReads = (item, state) => {
    const id = getNotificationId(item);
    return {
        ...item,
        _id: id,
        id,
        isRead: !!item.isRead || !!state.readIds[id],
    };
};

const mergeItems = (state, items) => {
    const merged = new Map();
    for (const item of [...state.notifications, ...items]) {
        const id = getNotificationId(item);
        if (!id) continue;
        const previous = merged.get(id);
        merged.set(id, applyKnownReads({ ...previous, ...item, isRead: !!previous?.isRead || !!item.isRead }, state));
    }
    return sortNotifications([...merged.values()].filter((item) => matchesNotificationFilters(item, state.filters)), state.filters.sort);
};

export default function adminNotifications(state = initialState(), action) {
    const payload = action.payload || {};
    if (payload.ownerId && payload.ownerId !== state.ownerId && action.type !== C.SET_OWNER) return state;

    switch (action.type) {
        case C.SET_OWNER:
            return state.ownerId === payload.ownerId ? state : { ...initialState(), ownerId: payload.ownerId };
        case C.CLEAR:
            return initialState();
        case C.SET_FILTERS:
            return { ...state, filters: { ...state.filters, ...payload } };
        case C.RESET_LIST:
            return {
                ...state,
                notifications: [],
                nextCursor: null,
                nextCursorId: null,
                hasMore: true,
                hasLoaded: false,
                loading: false,
                error: "",
                requestId: 0,
                generation: state.generation + 1,
            };
        case C.FETCH_PAGE_REQUEST:
            return { ...state, loading: true, error: "", requestId: payload.requestId };
        case C.FETCH_PAGE_FAILURE:
            if (payload.requestId !== state.requestId || payload.generation !== state.generation) return state;
            return { ...state, loading: false, error: payload.message };
        case C.FETCH_PAGE_SUCCESS:
            if (payload.requestId !== state.requestId || payload.generation !== state.generation) return state;
            return {
                ...state,
                notifications: mergeItems(state, payload.items || []),
                nextCursor: payload.nextCursor,
                nextCursorId: payload.nextCursorId,
                hasMore: !!payload.hasMore,
                hasLoaded: true,
                loading: false,
                error: "",
            };
        case C.COUNTS_REQUEST:
            return { ...state, countsLoading: true, countsRequestId: payload.requestId };
        case C.COUNTS_SUCCESS:
            if (payload.requestId && payload.requestId !== state.countsRequestId) return state;
            if (payload.activityVersion !== state.activityVersion) return state;
            return { ...state, ...getNotificationStats(payload), countsLoading: false, countsError: "" };
        case C.COUNTS_FAILURE:
            if (payload.requestId !== state.countsRequestId) return state;
            return { ...state, countsLoading: false, countsError: payload.message };
        case C.RECEIVED:
            return {
                ...state,
                notifications: mergeItems(state, [payload.notification || payload]),
                activityVersion: state.activityVersion + 1,
            };
        case C.MARK_READ: {
            const id = getNotificationId(payload.id || payload.notification || action.payload);
            if (!id) return state;
            const next = { ...state, readIds: { ...state.readIds, [id]: true }, activityVersion: state.activityVersion + 1 };
            return { ...next, notifications: mergeItems(next, payload.notification ? [payload.notification] : []) };
        }
        case C.MARK_ALL_READ: {
            const cutoff = new Date(payload.readBefore).getTime();
            if (!Number.isFinite(cutoff)) return state;
            const previous = state.readBefore ? new Date(state.readBefore).getTime() : 0;
            const next = {
                ...state,
                readBefore: new Date(Math.max(previous, cutoff)).toISOString(),
                activityVersion: state.activityVersion + 1,
                generation: state.generation + 1,
                requestId: 0,
                loading: false,
                notifications: state.notifications.map((item) => new Date(item.createdAt).getTime() <= cutoff ? { ...item, isRead: true } : item),
            };
            return { ...next, notifications: mergeItems(next, []) };
        }
        default:
            return state;
    }
}
